module.exports = __webpack_public_path__ + "b394a4112f40c3e3290ce7b982978a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pdf.png
// module id = 211
// module chunks = 0